export default {
  addHours (time, toAdd) {
    const parts = time.split(':');
    const h = Number(parts[0]);
    const m = parts[1];
    let hh = h + Number(toAdd);

    if (hh > 23) {
      hh = hh - 24;
    }
    return `${hh}:${m}`;
  },
  dateToWeek (dateString) {
    const d = new Date(dateString);
    const dayNum = d.getDay();
    // console.groupCollapsed('dateToWeek')

    // console.log('dateToWeek date', d);
    // console.log('dateToWeek dayNum', dayNum);
    // console.log('dateToWeek dateString', dateString);

    // Get difference of days to same weeks monday
    const diff = (dayNum - 1) < 0 ? 6 : (dayNum - 1);
    // console.log('dateToWeek diff', diff);

    // Move the date to monday
    d.setDate(d.getDate() - diff);
    // console.log('dateToWeek new date', d);

    // Return date portion of iso-date
    // console.groupEnd();
    return this.toISO(d);
  },
  addDays (dateString, toAdd) {
    const d = new Date(dateString)
    d.setDate(d.getDate() + toAdd);
    return this.toISO(d);
  },
  timesOverlap (start1, end1, start2, end2) {
    const s1 = Number(start1.split(':').join(''));
    const s2 = Number(start2.split(':').join(''));
    const e1 = Number(end1.split(':').join(''));
    const e2 = Number(end2.split(':').join(''));
    // console.log('s1 :', s1);
    // console.log('e1 :', e1);
    // console.log('s2 :', s2);
    // console.log('e2 :', e2);
    return (s1 < e2 && e1 > s2);
  },
  currentDate () {
    return this.toISO(new Date());
  },
  toISO (date) {
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    const mm = m < 10 ? '0' + m : m;
    const dd = d < 10 ? '0' + d : d;

    return `${y}-${mm}-${dd}`;
  },
  getWeekDay (isoDate, localizedDays) {
    return localizedDays[new Date(isoDate).getDay()];
  },
  getWeekNumber (dateString) {
    var date = new Date(dateString);
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    var week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
  },
  toFIN (isoDate) {
    return isoDate.split('-').reverse().join('.');
  },
  toShortFIN (isoDate) {
    return isoDate.split('-').reverse().join('.').substring(0, 6);
  },
  getDatesForWeek (date) {
    const week = this.dateToWeek(date);
    const array = [week];
    let i;
    for (i = 1; i < 7; i++) {
      array.push(this.addDays(week, i));
    }
    return array;
  }
}



// WEBPACK FOOTER //
// ./src/utils/TimeUtils.js